/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const config = useRuntimeConfig();

const DISCOVERY_DOCS = ["https://sheets.googleapis.com/$discovery/rest?version=v4"];
let directAccess = false;

const load = () => {
  return new Promise(function (resolve, reject) {
    if (window.gapi === undefined) {
      installClient().then(function () {
        return initClient()
      }).then(function () {
        resolve()
      })
      return;
    }
    initClient().then(function () { resolve() })
  })
}

const installClient = () => {
  return new Promise(function (resolve, reject) {
    const script = document.createElement('script')
    script.src = `https://apis.google.com/js/api.js`;
    script.onreadystatechange = script.onload = function () {
      if (!script.readyState || /loaded|complete/.test(script.readyState)) {
        setTimeout(function () { resolve() }, 500)
      }
    }
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

const initClient = () => {
  return new Promise(function (resolve, reject) {
    window.gapi.load('client:auth2', function () {
      window.gapi.client.init({
        clientId: config.public.GOOGLE_CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: config.public.GOOGLE_SCOPE,
      })
      resolve()
    })
  })
}

const signIn = (successCallback, errorCallback) => {
  const authClient = window.gapi.auth2;
  if (authClient.getAuthInstance().isSignedIn.get()) return successCallback(gapi.client.getToken().access_token);

  if (directAccess) {
    window.gapi.auth2.getAuthInstance().signIn().then((googleUser) => {
      return successCallback(googleUser);
    }, (error) => { return errorCallback(error) } )
  }

  window.gapi.auth2.getAuthInstance().grantOfflineAccess({ 'redirect_uri': 'postmessage' }).then((response) => {
    return successCallback(response.code)
  }, (error) => { return errorCallback(error) })
}

export default {
  load,
  signIn,
};
